import React, { useEffect, useState } from 'react';
import { AiOutlineMenu } from 'react-icons/ai';
import { FiShoppingCart } from 'react-icons/fi';
import { BsChatLeft } from 'react-icons/bs';
import { RiNotification3Line } from 'react-icons/ri';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';

import avatar from '../data/avatar.jpg';
import { Cart, Chat, Notification, UserProfile } from '.';
import { useStateContext } from '../contexts/ContextProvider';
import { Header, Button, Pie, ChartsHeader } from './';
import { useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';

const NavButton = ({ title, customFunc, icon, color, dotColor }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ color }}
      className="relative text-xl rounded-full p-3 hover:bg-light-gray"
    >
      <span
        style={{ background: dotColor }}
        className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
      />
      {icon}
    </button>
  </TooltipComponent>
);

const Navbar = () => {
  const { currentColor, activeMenu, setActiveMenu, handleClick, isClicked, setScreenSize, screenSize } = useStateContext();
  const navigate = useNavigate();
  const [userId, setUserId] = useState('');
  const [unixTime, setUnixTime] = useState('');

  useEffect(() => {
    const storedUserID = localStorage.getItem('userId');
    setUserId(storedUserID || '');
    console.log(`storedUserID: ${storedUserID}`);

    const storedUnixTime = localStorage.getItem('unixTime');
    setUnixTime(storedUnixTime || '');
    console.log(`storedUnixTime: ${storedUnixTime}`);

    const handleResize = () => setScreenSize(window.innerWidth);

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (screenSize <= 900) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }, [screenSize]);

  const handleActiveMenu = () => setActiveMenu(!activeMenu);

  const handleProjectReset = () => {
    Swal.fire({
      title: `프로젝트를 초기화하시겠습니까?`,
      html : `관리자 외 초기화 버튼을 클릭하지 마세요.`,
      icon: 'warning',
      confirmButtonText: '초기화하기',
      confirmButtonColor : 'rgb(215, 78, 114)',
      cancelButtonText : '취소하기',
      cancelButtonColor : currentColor,
      showCancelButton: true, // 취소 버튼 표시
    }).then((result) => {
      if (result.isConfirmed) {
        navigate('/');
        window.location.reload(); // 화면 강제 새로고침
        localStorage.setItem('userId', "");
        setUserId("")
        setUnixTime("")
        Swal.fire({
          title: `프로젝트 초기화 완료`,
          icon: 'success',
          confirmButtonColor : currentColor,
          confirmButtonText: '확인',
          
        })
        
      }
    });
    

  }

  return (
    <div className="flex justify-between p-2 md:ml-6 md:mr-6 relative ">

      <NavButton title="Menu" customFunc={handleActiveMenu} color={currentColor} icon={<AiOutlineMenu />} />
      <div className="flex gap-3 items-center" >
        <p className="text-s" ><span style={{ color: '#39FF14' }}>●</span> 프로젝트명: 토스앱리뷰_240101-240631.csv</p>

        
        <Button
          color="white"
          bgColor={currentColor}
          text="테스트 안내"
          borderRadius="10px"
          onClick={() => navigate('/')}
        />

        <Button
          color="white"
          bgColor={'rgb(215, 78, 114)'}
          text="프로젝트 초기화"
          borderRadius="10px"
          onClick={()=>handleProjectReset()}
        />

        {/* <NavButton title="Cart" customFunc={() => handleClick('cart')} color={currentColor} icon={<FiShoppingCart />} />
        <NavButton title="Chat" dotColor="#03C9D7" customFunc={() => handleClick('chat')} color={currentColor} icon={<BsChatLeft />} />
        <NavButton title="Notification" dotColor="rgb(254, 201, 15)" customFunc={() => handleClick('notification')} color={currentColor} icon={<RiNotification3Line />} /> */}
        {/* <TooltipComponent content="Profile" position="BottomCenter">
          <div
            className="flex items-center gap-2 cursor-pointer p-1 hover:bg-light-gray rounded-lg"
            onClick={() => handleClick('userProfile')}
          >
            <img
              className="rounded-full w-8 h-8"
              src={avatar}
              alt="user-profile"
            />
            <p>
              <span className="text-gray-400 text-14">Hi,</span>{' '}
              <span className="text-gray-400 font-bold ml-1 text-14">
                Michael
              </span>
            </p>
            <MdKeyboardArrowDown className="text-gray-400 text-14" />
          </div>
        </TooltipComponent> */}

        {/* {isClicked.cart && (<Cart />)}
        {isClicked.chat && (<Chat />)}
        {isClicked.notification && (<Notification />)}
        {isClicked.userProfile && (<UserProfile />)} */}
      </div>
    </div>
  );
};

export default Navbar;
